import axios from 'axios';
import { storage } from './storage';

const 
    username = storage.retrieve("username"),
    password = storage.retrieve("password"),
    tfaToken = storage.retrieve("tfa_token");

const authChain = window.btoa(`${username}:${tfaToken ? tfaToken : password}`);

export const api = axios.create({
	baseURL: process.env.REST_API_URL,
	headers: {
		'Content-Type' : 'application/json',
		'Authorization': `Basic ${authChain}`
	}
});

export const rtm = axios.create({
	baseURL: 'https://previews.ada.support/',
	headers: {
		'Content-Type' : 'application/json',
		'Authorization': `Basic ${authChain}`
	}
});


// WEBPACK FOOTER //
// ./src/services/http.js